import { Accordion, Div, Text } from "view/lib/components";
import Title from "view/lib/components/title";

const placeholder = [{
  title: "Title 1",
  subdomains: [{
    title: "Subtitle 1",
    descriptions: ["Description 1", "Description 2"]
  }, {
    title: "Subtitle 2",
    descriptions: ["Description 1", "Description 2"]
  }]
}, {
  title: "Title 2", 
  subdomains: [{
    title: "Subtitle 1",
    descriptions: ["Description 1", "Description 2"]
  }, {
    title: "Subtitle 2",
    descriptions: ["Description 1", "Description 2"]
  }]
}];

interface Props {
  readonly data: Record<string, any>;
}

const Services = ({ data }: Props) =>
  <Div style={styles.container}>
    <Title title="Services" />
    {
      data.work.map((item: Record<string, any>) =>
        <Accordion key={item.title} title={item.title} item={workItem(item.description)}/>
    )}
    <Div style={styles.section}>
      <Text style={styles.biographyTitle}>// Skills</Text>
      <table style={styles.table}>
        <tbody>
          <tr>
            <td style={styles.td}>Programming Languages</td>
            <td style={styles.td}><Text>{data.skills.programmingLanguages.join(", ")}</Text></td>
          </tr>
          <tr>
            <td style={styles.td}>Front-End Technologies</td>
            <td style={styles.td}><Text>{data.skills.frontendTechnologies.join(", ")}</Text></td>
          </tr>
          <tr>
            <td style={styles.td}>Back-End Technologies</td>
            <td style={styles.td}><Text>{data.skills.backendTechnologies.join(", ")}</Text></td>
          </tr>
          <tr>
            <td style={styles.td}>Version Control</td>
            <td style={styles.td}><Text>{data.skills.versionControl.join(", ")}</Text></td>
          </tr>
          <tr>
            <td style={styles.td}>Tools and Frameworks</td>
            <td style={styles.td}><Text>{data.skills.toolsAndFrameworks.join(", ")}</Text></td>
          </tr>
        </tbody>
      </table>
    </Div>
  </Div>;

const workItem = (description: ReadonlyArray<string>) =>
  <ul style={styles.list}>
    {
      description.map((item, index) => <li key={index}><Text>{item}</Text></li>)
    }
  </ul>

const styles = {
  container: {
    padding: "3%"
  },
  biographyTitle: {
    fontSize: "x-large"
  },
  section: {
    margin: "2% 0%"
  },
  columnName: {
    fontSize: "large"
  },
  table: {
    width: "100%",
    border: "1px solid black"
  },
  td: {
    padding: "1%",
    border: "1px solid black"
  },
  list: {
    listStyleType: "circle"
  }
}

export default Services;